import { AbbDashboardComponent } from './abb-dashboard.component';
export var AbbDashboardRoutes = [
    {
        path: 'abb-dashboard',
        component: AbbDashboardComponent,
        data: {
            'expectedRoles': ['Admin', 'Accountant', 'Accountant Admin']
        }
    }
];
var AbbDashboardRoutingModule = (function () {
    function AbbDashboardRoutingModule() {
    }
    return AbbDashboardRoutingModule;
}());
export { AbbDashboardRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard-routing.module.ts.pre-build-optimizer.js